import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { getReferral, saveReferral } from "@/lib/referral";

let pending = null;

export default function ReferralCapture() {
  const { search } = useLocation();

  useEffect(() => {
    const code = new URLSearchParams(search).get("parrain");
    if (!code || getReferral()?.code === code.toUpperCase() || pending === code.toUpperCase()) return;
    pending = code.toUpperCase();
    api.get(`/referral/${encodeURIComponent(code)}`).then(({ data }) => {
      saveReferral({ code: data.code, referrer_name: data.referrer_name, welcome_used: Boolean(getReferral()?.welcome_used) });
      toast.success(
        data.welcome_discount_percent > 0
          ? `Bienvenue ! ${data.referrer_name} vous offre −${data.welcome_discount_percent} % sur votre première commande en créant votre compte.`
          : `Bienvenue ! Vous avez été invité·e par ${data.referrer_name}.`,
        { duration: 7000 },
      );
    }).catch(() => {});
  }, [search]);

  return null;
}
